<template>
 <AdminPanelEpicentrkMegogoPackageSelling />
</template>

<script>
import AdminPanelEpicentrkMegogoPackageSelling from '../components/AdminPanelEpicentrkMegogoPackageSelling.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEpicentrkMegogoPackageSelling
    },
    methods: {},
    mounted() {}
}
</script>
